import React from 'react';
import styled from 'styled-components';
import { node, bool, string, func } from 'prop-types';

const Button = ({
  className,
  children,
  disabled,
  type,
  onClick,
  secondary,
  long,
  dataTestId,
}) => (
  <StyledButton
    data-test-id={dataTestId}
    long={long}
    className={className}
    disabled={disabled}
    type={type}
    secondary={secondary}
    onClick={() => onClick()}
  >
    {children}
  </StyledButton>
);

const StyledButton = styled.button`
  background-color: ${({ theme, secondary }) =>
    secondary ? theme.ui.disabled : theme.brand.primary};
  width: ${props => (props.long ? '30rem' : '15rem')};
  height: 3.5rem;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  color: white;
  border: 0;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease 0s;

  &:active {
    outline: none;
    transform: scale(0.98);
  }

  &:focus {
    border: 0 0 0;
    outline: none;
  }

  &:disabled {
    cursor: default;
    background-color: ${({ theme }) => theme.ui.disabled};
  }

  @media screen and (max-width: 1025px) {
    transform: scale(0.9);
    margin-bottom: 1rem;

    &:active {
      transform: scale(0.88);
    }
  }
`;

Button.defaultProps = {
  disabled: false,
  type: 'button',
  children: '',
  className: '',
  onClick: () => {},
  secondary: false,
  long: false,
};

Button.propTypes = {
  children: node,
  disabled: bool,
  type: string,
  onClick: func,
  className: string,
  dataTestId: string,
  secondary: bool,
  long: bool,
};

export default Button;
